/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ReactComponent as RightArrow } from "cms/assets/icons/arrow-right.svg";

const IconLinkItem = (props) => {

    const iconLink = props?.iconLink;
    const iconUrl = iconLink?.icon;
    const link = iconLink?.link;
    const linkUrl = link?.url;
    const linkText = link?.text;

    return (
        <a className='icon-link-item' href={linkUrl}>
            <img alt='icon' src={iconUrl} />
            {linkText}
            <RightArrow className='right-arrow' />
        </a>
    );
};

IconLinkItem.displayName = "IconLinkItem";
export { IconLinkItem };
